import React from 'react'
import { connect } from 'react-redux'
import { message } from 'antd'
import './style.css'
import Header4 from '../../../Header/Header4';
import { SpaceBasedPlan, CommonAppSupport, ServiceSystem, SatelliteSystem, Chronicles, Profile } from './component/index'
import { menuPageList } from './component/Datas/normalDatas'
import HomeHearder from 'src/components/Pages/Home/NewHome/HomeHearder'
import { MainBottom } from 'src/components/Pages/Guide/component/index'
import { unitsList } from 'src/components/Pages/Guide/component/Datas/normalDatas'

class Introduce extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectMenuIndex: 0,
        };
    }

    componentDidMount = () => {
        let index = this.props.location.state && this.props.location.state.index;
        console.log('rr', this.props.location)
        if (index || index === 0) this.setState({ selectMenuIndex: index });
    }

    componentDidUpdate = (preProps) => {
        let index = this.props.location.state && this.props.location.state.index;
        let preIndex = preProps.location.state && preProps.location.state.index;
        // console.log("componentDidUpdate", '',index, preIndex,);
        if ((index || index === 0) && index !== preIndex) this.setState({ selectMenuIndex: index });
        // let index = sessionStorage.getItem('introduceIndex');
        // this.setState({selectMenuIndex: index});
    }

    returnSelectPage = () => {
        const { selectMenuIndex } = this.state;
        switch (selectMenuIndex) {
            case 0:
                return <SpaceBasedPlan />;
            case 1:
                return <SatelliteSystem />;
            case 2:
                return <CommonAppSupport />;
            case 3:
                return <ServiceSystem />;
            case 4:
                return <Chronicles />;
            case 5:
                return <Profile />;
            default:
                message.error("无效的菜单选择！");
                break;
        }
    }

    setNowSelctMenu = (index) => {
        this.setState({ selectMenuIndex: index });
        // sessionStorage.setItem('introduceIndex', index);
    }


    render() {
        const { selectMenuIndex } = this.state;
        return (
            <div className='Home_Introduce'>
                <div className='Home_IntroduceMain' id='Home_IntroduceMain'>
                    {/* <Header4></Header4> */}
                    <div className='Home_IntroduceTitle'>
                        {this.props.loginObj && this.props.loginObj.login && this.props.loginObj.token !== undefined
                            ?
                            <Header4 />
                            :
                            <HomeHearder />
                        }
                    </div>
                    <div className='Home_IntroduceMainScroll'>
                        <div className='Home_IntroduceContent'>
                            <div className='Home_IntroduceContentMain'>
                                <div className='Home_IntroduceContentLeft'>
                                    {this.returnSelectPage()}
                                </div>
                                <div className='Home_IntroduceMenuList'>
                                    {menuPageList.map((menu, index) => {
                                        return <div
                                            className={index === selectMenuIndex ? 'Home_IntroduceMenu_Select' : 'Home_IntroduceMenu'}
                                            onClick={() => this.setNowSelctMenu(index)}>{menu.title}</div>
                                    })}
                                </div>
                            </div>
                        </div>
                        <MainBottom data={unitsList} />
                    </div>
                </div>
            </div>
        )
    }
}

const mapState = (state) => ({
    loginObj: state.userReducer.get('loginObj').toJS(),
    user: state.userReducer.get('user').toJS()
})
const mapDispatch = (dispatch) => ({})
export default connect(mapState, mapDispatch)(Introduce);

